import React, { useState } from 'react';
import TrialProfileIllustration from '../../assets/trial_profile_illustration.svg';
import { Formik, Form, FormikHelpers as FormikActions } from 'formik';
import { FieldInput } from '@magoosh/lib/formik_inputs/field_input/template';
import { Grid, Row, Col } from 'react-bootstrap';
import { SecondaryButton } from '@magoosh/lib/button';
import { paths } from 'config/path_helpers';
import fetch from 'utilities/fetch';
import { WelcomeFormProps } from './types';
import { DateSelect } from '@magoosh/lib/forms';

export const Welcome: React.FC<WelcomeFormProps> = (props) => {
  const initialValues: WelcomeFormProps = {
    firstName: props.firstName,
    lastName: props.lastName,
    testDate: props.testDate,
    heardFrom: props.heardFrom
  };

  const [testDateDisabled, setTestDateDisabled] = useState(false);

  const handleOnSubmit = (
    values: WelcomeFormProps,
    { setSubmitting }: FormikActions<WelcomeFormProps>
  ): void => {
    setSubmitting(true);
    fetch(paths.api.userProfile(), {
      method: 'PATCH',
      body: JSON.stringify({ userProfile: values })
    }).then(() => {
      window.location.assign(paths.dashboard());
    });
  };

  return (
    <Grid className="u-padding-T-m" style={{ paddingBottom: '64px' }}>
      <Row>
        <Col sm={2} smPush={7}>
          <img src={TrialProfileIllustration} alt="GRE student wearing glasses and a bunny hat" />
        </Col>
        <Col sm={1}></Col>
        <Col sm={4}>
          <h2>Create Your Profile</h2>
          <p>Add a few details about yourself to get the most out of your free trial.</p>
        </Col>
      </Row>
      <Row>
        <Col sm={6} smOffset={3}>
          <Formik initialValues={initialValues} onSubmit={handleOnSubmit}>
            {({ values, isSubmitting, handleSubmit, setFieldValue }) => {
              return (
                <Form>
                  <FieldInput
                    name="firstName"
                    type="input"
                    label="First Name"
                    placeholder="Enter your first name."
                  />
                  <FieldInput
                    name="lastName"
                    type="input"
                    label="Last Name (Family Name)"
                    placeholder="Enter your last name."
                  />
                  <label className="u-margin-T-l">Test Date</label>
                  <div style={{ marginBottom: '-10px' }}>
                    <DateSelect
                      onChange={(value) => setFieldValue('testDate', value)}
                      inline
                      selectClassName="u-margin-R-xs"
                      disabled={testDateDisabled}
                      value={values.testDate}
                      key={testDateDisabled ? 1 : 0}></DateSelect>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="noTestDate"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setTestDateDisabled(true);
                          setFieldValue('testDate', null);
                        } else {
                          setTestDateDisabled(false);
                        }
                      }}></input>
                    <label className="form-check-label u-margin-L-xs" htmlFor="noTestDate">
                      I don't have a test date.
                    </label>
                  </div>
                  <div className="u-margin-T-l"></div>
                  <FieldInput
                    name="heardFrom"
                    type="input"
                    label="How did you hear about Magoosh?"
                    placeholder="For example: word of mouth, Google search, YouTube, etc."
                  />
                  <SecondaryButton
                    className="u-margin-T-l"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    block>
                    Start Free Trial
                  </SecondaryButton>
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Grid>
  );
};

export default Welcome;
